<template>
  <div class="mt-3">
    <b-form>
      <b-row>
        <b-col xl="12" lg="12" sm="12">
          <b-input-group prepend="IMSI" label-for="input-1">
            <b-form-input
                :state="true"
                v-model="terminateSubscriberForm.imsiInfo"
                required
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>

      <hr>
      <b-row class="mt-3 justify-content-end">
        <b-col>
          <div class="float-right">
            <base-button id="btn-terminate-modal-submit" type="primary" title="Submit" v-on:click="terminateSubscriberSubmit()">
              Submit
            </base-button>
          </div>
        </b-col>
      </b-row>

    </b-form>

    <!--no-close-on-backdrop-->
    <b-modal centered size="sm" id="activity_progress_bar" hide-footer hide-header
             class="activity_progress_bar ">
      <p class="h1 text-center mb-4">Activity</p>
      <b-progress :value="progressStartValue" height="16px" variant="primary" :striped="true"
                  class="mt-2" :animated="true" show-progress></b-progress>
      <div class="text-center">
        <small class="text-center" v-if="progressTitle">{{ progressTitle }}</small>
        <br>
        <small class="text-center" v-if="progressMessage">{{ progressMessage }}</small>
      </div>
    </b-modal>
  </div>
</template>

<script>
import provisioningService from "@/common/api-services/provisioning-service";
import ToastVue from "@/views/Components/Toast.vue";
import configDirective from "@/common/directive/config-directive";
import AuthService from "@/common/api-services/auth-service";

export default {
  name: "Terminate-Subscriber",
  components: {ToastVue},
  data() {
    return {
      lastMessage: "",
      terminateSubscriberForm: {
        imsiInfo: ''
      },
      progressTitle: null,
      progressMessage: null,
      progressStartValue: 5,
    }
  },
  computed: {
    submitDisabled() {
      return this.terminateSubscriberForm.imsiInfo.length === 15 ? false : true;
    }
  },
  mounted() {
    this.$bvModal.hide('activity_progress_bar');
    this.$root.$on('sendIMSIInfo', (imsi => {
      this.terminateSubscriberForm.imsiInfo = imsi;
    }))
  },
  methods: {

    setProgressTimer() {
      this.timer = setInterval(() => {
        this.progressStartValue = this.progressStartValue + Math.random() * 300 / this.progressStartValue;
        if (this.progressStartValue > 100) {
          this.progressStartValue = 10
        }
      }, 1000);
    },

    terminateSubscriberSubmit() {
      if (process.env.NODE_ENV === 'dev') console.warn('[DEBUG][SimDetail.vue] terminateSubscriberSubmit...', Date.now(), Date());
      let re = /^[0-9]{15}$/gm;
      if (!re.test(this.terminateSubscriberForm.imsiInfo)) {
        let msg = {
          status: "ERROR",
          response: {
            error: "Invalid IMSI: " + this.terminateSubscriberForm.imsiInfo
          }
        };
        this.processMessage(msg);
        return;
      }

      //do the IOT version
      if (configDirective.isIOTOnly()) {
        provisioningService.submitSimpleTerminate(this.terminateSubscriberForm.imsiInfo).then(res => {
          if (res) {
            this.$toast.success({
              component: ToastVue,
              props: {
                title: 'TERMINATE Subscriber: OK',
                description: res.join("<br>")
              }
            }, {
              timeout: 45000
            })
            this.closeModal();
          } else {
            this.$toast.error({
              component: ToastVue,
              props: {
                title: 'TERMINATE Subscriber: FAILED',
                description: res.join("<br>")
              }
            }, {
              timeout: 45000
            })
          }
        }).catch(err => {
          this.$toast.error({
            component: ToastVue,
            props: {
              title: 'TERMINATE Subscriber: FAILED',
              description: JSON.stringify(err)
            }
          }, {
            timeout: 45000
          })
        });

      } else {

        this.$bvModal.show('activity_progress_bar');
        this.progressTitle = 'Processing Actions';
        this.progressMessage = 'Removing Subscriber...';
        this.setProgressTimer();
        let imsi = this.terminateSubscriberForm.imsiInfo;

        provisioningService.submitTerminateSubscriber(imsi).then(queueid => {
          //if (process.env.NODE_ENV === 'dev')
            console.warn('[DEBUG][SimDetail.vue] submitTerminateSubscriber.queueid:', queueid);
          if (typeof queueid === 'undefined') throw new Error('TERMINATE ACTION failed.');

          if (!configDirective.hasPolling()) {
            if (JSON.stringify(queueid).toLowerCase().includes('error') || JSON.stringify(queueid).toLowerCase().includes('fail')) throw new Error(JSON.stringify(queueid));
            
            this.addLog(queueid, 0)
            this.$toast.success({
              component: ToastVue,
              props: {
                title: 'Terminate Subscriber',
                subtitle: 'The SIM was terminated successfully and is now available for reuse.',
                //description: JSON.stringify(queueid)
              }
            });
            this.closeModal();

          } else {

            provisioningService.getPollUntilDone(queueid, 60000, 1000, this.processMessage).then(response => {
              if (process.env.NODE_ENV === 'dev') console.warn('[DEBUG][SimDetail.vue] getPollUntilDone.response:', response);
              if (response.status && response.status === 'DONE') this.processMessage(response);
            }).catch(e => {
              console.error(e);
              let msg = [];
              msg.status = 'ERROR';
              msg.details = e.toString();
              this.processMessage(msg);
            });
          }
        }).catch(e => {
          this.addLog(e, 1)
          this.$toast.error({
            component: ToastVue,
            props: {
              title: 'Terminate Subscriber',
              subtitle: 'There was an error removing the SIM from the system.  Please try again or refer to the logs for more details.',
              description: e.toString()
            }
          })
          this.closeModal();
        });
      }
    },

    processMessage(msg) {

      if (!msg || String(msg).length < 5) return;
      if (JSON.stringify(this.lastMessage) === JSON.stringify(msg)) return;
      if (process.env.NODE_ENV === 'dev') console.log('TERMINATE:', msg);

      if (JSON.stringify(msg).toLowerCase().indexOf('error') || JSON.stringify(msg).toLowerCase().indexOf('fail')) {
        msg.status === 'ERROR';
      }

      if (msg.status === 'DONE' || msg.status === 'ERROR') {
        this.addLog(msg.response, msg.status === 'ERROR' ? 1 : 0)
        let messageData = '';
        if (msg && msg.response) {
          try {
            let j = JSON.parse(msg.response);
            if (j.success) {
              j.success.map(item => {
                messageData = messageData + item + `<br>`
              });
            }
            if (j.error) {
              j.error.map(item => {
                messageData = messageData + item + `<br>`
              });
            }
          } catch (e) {
            console.error(e);
          } //ignore
        }

        if (process.env.NODE_ENV === 'dev') {
          console.log("processMessage.msg:", msg);
          console.log("processMessage.STATUS:", msg.status);
          console.log("processMessage.messageData:", messageData);
        }

        if (msg.status === 'ERROR') {
          if (typeof msg.details === 'undefined') {
            // this.addLog(messageData, 1)
            this.$toast.error({
              component: ToastVue,
              props: {
                title: 'Terminate Subscriber',
                subtitle: 'There was an error removing the SIM from the system.  Please try again or refer to the logs for more details.',
                description: JSON.stringify(messageData)
              }
            })
          }
        } else {
          // this.addLog(messageData, 0)
          this.$toast.success({
            component: ToastVue,
            props: {
              title: 'Terminate Subscriber',
              subtitle: 'The SIM was terminated successfully and is now available for reuse.',
              description: JSON.stringify(messageData)
            }
          })
          //this.$root.$emit('reloadSimDetailPageData', this.terminateSubscriberForm.imsiInfo);
        }
        this.closeModal();
      } else {
        this.progressMessage = msg.status;
      }
      this.lastMessage = msg;
    },

    addLog(details, isError=0) {
      AuthService.setActivityLog("Mobility: Terminate Subscriber", details, isError)
    },

    closeModal() {
      //reload the page data or just show it.
      this.progressMessage = 'Refreshing Subscriber data...';
      //window.location.reload();
      this.$forceUpdate();
      this.$root.$emit('reloadSimDetailPageData', this.terminateSubscriberForm.imsiInfo);

      setTimeout(() => {
        this.$bvModal.hide('activity_progress_bar');
        this.$bvModal.hide('terminate-subscriber');
      }, 1000);
    },

  }
}
</script>
